// extracted by mini-css-extract-plugin
export default {"uiTpaColoPicker":"UKyaAS","description":"OINeio","actionable":"s_PrLG","colorSamplerGroup":"eP4wAY"};